









































import { defineComponent, computed, ref, PropType, watch } from '@nuxtjs/composition-api'

import CitationCarouselCard from './CitationCarouselCard.vue'
import IconFa6SolidAngleLeft from '~icons/fa6-solid/angle-left'
import IconFa6SolidAngleRight from '~icons/fa6-solid/angle-right'

import { useMobile } from '~/composables/ui/useMobile'
import { CitationImageExtended } from '~/types/product/productTypes'

export default defineComponent({
  components: {
    CitationCarouselCard,
    IconFa6SolidAngleLeft,
    IconFa6SolidAngleRight,
  },
  props: {
    citationsImages: {
      type: Array as PropType<CitationImageExtended[]>,
      required: false,
      default: () => [],
    },
    currentImage: {
      type: Number,
      required: true,
    },
  },
  emits: ['carouselCartClick'],
  setup(props) {
    const citationImagesCarousel = ref()
    const slickOptions = {
      arrows: false,
      slidesToShow: 3,
      lazyLoad: 'ondemand',
      infinite: false,
      initialSlide: props.currentImage,
      responsive: [
        {
          breakpoint: 399,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    }

    const { isMobile, isTablet } = useMobile()

    const CAROUSEL_MAX_VISIBLE_IMAGES_MOBILE = 1
    const CAROUSEL_MAX_VISIBLE_IMAGES_TABLET = 2
    const CAROUSEL_MAX_VISIBLE_IMAGES_DESKTOP = 3

    const maxIndex = computed(
      () =>
        props.citationsImages.length -
        (isMobile.value
          ? CAROUSEL_MAX_VISIBLE_IMAGES_MOBILE
          : isTablet.value
          ? CAROUSEL_MAX_VISIBLE_IMAGES_TABLET
          : CAROUSEL_MAX_VISIBLE_IMAGES_DESKTOP)
    )

    const backDisabled = ref(props.currentImage <= 0)
    const futureDisabled = ref(
      props.currentImage +
        (isMobile.value
          ? CAROUSEL_MAX_VISIBLE_IMAGES_MOBILE
          : isTablet.value
          ? CAROUSEL_MAX_VISIBLE_IMAGES_TABLET
          : CAROUSEL_MAX_VISIBLE_IMAGES_DESKTOP) >
        props.citationsImages.length - 1
    )

    const isMultipleImages = computed(() => {
      return (
        props.citationsImages.length >
        (isMobile.value
          ? CAROUSEL_MAX_VISIBLE_IMAGES_MOBILE
          : isTablet.value
          ? CAROUSEL_MAX_VISIBLE_IMAGES_TABLET
          : CAROUSEL_MAX_VISIBLE_IMAGES_DESKTOP)
      )
    })

    const onArrowClick = (whereTo: string) => {
      if (whereTo === 'next') {
        citationImagesCarousel.value.next()
      } else {
        citationImagesCarousel.value.prev()
      }
    }

    const onBeforeChange = (_oldSlideIndex: number, slideIndex: number) => {
      backDisabled.value = slideIndex <= 0
      futureDisabled.value =
        slideIndex +
          (isMobile.value
            ? CAROUSEL_MAX_VISIBLE_IMAGES_MOBILE
            : isTablet.value
            ? CAROUSEL_MAX_VISIBLE_IMAGES_TABLET
            : CAROUSEL_MAX_VISIBLE_IMAGES_DESKTOP) >
        props.citationsImages.length - 1
    }

    // .. Wait for change in parent
    watch(
      () => props.currentImage,
      () => {
        if (citationImagesCarousel.value && citationImagesCarousel.value?.goTo) {
          backDisabled.value = props.currentImage <= 0
          futureDisabled.value =
            props.currentImage +
              (isMobile.value
                ? CAROUSEL_MAX_VISIBLE_IMAGES_MOBILE
                : isTablet.value
                ? CAROUSEL_MAX_VISIBLE_IMAGES_TABLET
                : CAROUSEL_MAX_VISIBLE_IMAGES_DESKTOP) >
            props.citationsImages.length - 1
          citationImagesCarousel.value?.goTo(Math.min(props.currentImage, maxIndex.value))
        }
      }
    )

    return {
      onArrowClick,
      slickOptions,
      isMultipleImages,
      citationImagesCarousel,
      backDisabled,
      futureDisabled,
      onBeforeChange,
    }
  },
})
